<div *ngIf='form as form' [formGroup]="form">
  <fieldset>
    <legend>
      Decyzje
    </legend>
    <app-location-decisions-crud formControlName="locationDecisions">
    </app-location-decisions-crud>
  </fieldset>
  <fieldset>
    <legend>
      Etapy
    </legend>
    <app-tab-view
      [simple]='false'
      (onAddNew)='form.addStage()'
      addBtnTitle='Dodaj kolejny etap'
      [showAddButton]='true'
      [centered]='true'
      formArrayName='stages'>
      <ng-container *ngFor='let stageForm of form.getStageForms(); let i = index;'>
        <app-tab-panel
          (onClose)='form.removeStage(i)'
          [closeBtnDisabled]='i === 0'
          [showCloseBtn]='true'
          [name]='"Etap nr " + (i + 1)' [selected]='i === (form.stages.controls.length - 1)'>
          <app-occupation-of-lane-placement-construction-objects-stage-form
            [label]='"Etap nr " + (i + 1)'
            [canRemoveStage]='i !== 0'
            [serviceId]="serviceId()"
            [form]='stageForm'>
          </app-occupation-of-lane-placement-construction-objects-stage-form>
        </app-tab-panel>
      </ng-container>
    </app-tab-view>
  </fieldset>
</div>
